/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q6Inputs */

const en_cad_faq_q6 = /** @type {(inputs: Cad_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is CADCraft ready for production work?`)
};

/**
* | output |
* | --- |
* | "Is CADCraft ready for production work?" |
*
* @param {Cad_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q6 = /** @type {((inputs?: Cad_Faq_Q6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q6(inputs)
});
export { cad_faq_q6 as "cad.faq.q6" }